// extracted by mini-css-extract-plugin
export default {"emailTemplateContainer":"emailTemplateContainer__VCMDIpX1","emailTemplateAccordion":"emailTemplateAccordion__rYf99bh5","emailTemplateCopyButton":"emailTemplateCopyButton__ba4n5Bx2"};